var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mx-auto" },
    [
      _c("v-subheader", [_vm._v("Last Added Jumps")]),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.recentJumps,
          "items-per-page": 30
        },
        scopedSlots: _vm._u([
          {
            key: "item.startTime",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      new Date(item.startTime).toLocaleString("en-AU", {
                        timeZone: "UTC",
                        weekday: "short",
                        year: "numeric",
                        month: "short",
                        day: "numeric"
                      })
                    )
                  )
                ])
              ]
            }
          },
          {
            key: "item.created",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      new Date(item.created).toLocaleString("en-AU", {
                        timeZone: "UTC",
                        weekday: "short",
                        year: "numeric",
                        month: "short",
                        day: "numeric"
                      })
                    )
                  )
                ])
              ]
            }
          },
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "success white--text ma-2",
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.reschedule(item)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-update")
                    ])
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }